module.exports = __webpack_public_path__ + "build/img/cases.5469fcd2.jpg";